export const method = (controller, methodName) => {
  const method = controller[methodName]
  if (typeof method === 'function') {
    return method
  } else {
    return (...args) => { }
  }
}
